import { useContext } from "react";
import CartContext from "../../context/cart";
import UserContext from "../../context/user";

const CartNotSelected = () => {
  const { labels } = useContext(CartContext);
  const { userProfile } = useContext(UserContext);

  return (
    <>
      <div
        className="carrello-content__text"
        dangerouslySetInnerHTML={{
          __html: (labels?.WELFARE_CART_CAMPAIGN_CLOSED).replace(
            "[USER]",
            `<span translate="no">${userProfile?.firstName} ${userProfile?.lastName}</span>`
          ),
        }}
      />
      <div
        className="carrello-content__text carrello-content__text--border-top"
        dangerouslySetInnerHTML={{
          __html: labels?.WELFARE_CONTACT_US_INFO,
        }}
      />
    </>
  );
};

export default CartNotSelected;
